<template>
  <div id="list-decomptes-table">
    <decompte-table :tableEntry="tableParam" ref="decompte_beneficiaire"></decompte-table>
  </div>  
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../utils/auth'
import DecompteTable from './DecompteTable'

export default {
  props: ['benefId'],
  components: { DecompteTable },
  data() {
    return {
      // items: []
    }
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json'
    this.$axios.defaults.headers.common['Provider'] = getProvider()
  },
  mounted() {
    // this.$refs.decompte_beneficiaire.$refs.table.refresh()
  },
  computed: {
    tableParam: {
      get() {
        let request = {}
        request.benefId = this.benefId
        return request
      }
    },
  },
  methods: {
  }
}
</script>

<style>

</style>
